"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reverse = void 0;
/**
 * Returns the given points (e.g. bezier) in reverse order.
 * @param ps
 */
function reverse(ps) {
    return ps.slice().reverse();
}
exports.reverse = reverse;
//# sourceMappingURL=reverse.js.map